<div class="payments container_product" [class.payments--nopadding]="noPadding">
  <div class="payments__payment" *ngFor="let payment of payments">
    <svg-icon [name]="payment"></svg-icon>
  </div>
</div>
